import { Component, OnInit, Inject, PLATFORM_ID } from '@angular/core';
import { Job } from '../_models/job';
import { JobService } from '../_services/job.service';
import { ToastrService } from 'ngx-toastr';
import { AppConstants } from '../_constants/constants';
import { isPlatformBrowser } from '@angular/common';

@Component({
    selector: 'app-career',
    templateUrl: './career.component.html',
    styleUrls: ['./career.component.css'],
    standalone: false
})
export class CareerComponent implements OnInit {

    loading = true;
    jobs: Job[] = [];
    currentLanguage: string | null = null;

    constructor(
        private jobService: JobService,
        private toastService: ToastrService,
        @Inject(PLATFORM_ID) private platformId: Object
    ) {
        window.scrollTo(0, 0);
    }

    ngOnInit(): void {
        if (isPlatformBrowser(this.platformId)) {
            this.currentLanguage = localStorage.getItem(AppConstants.CURRENT_LANG_STORE_KEY);
        }
        this.jobService.loadJobs().subscribe(
            (jobs) => {
                this.jobs = jobs;
                this.loading = false;
            },
            (error) => this.toastService.error(error)
        )
    }
}
